import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommunicationService} from '../../../communication/services/communication.service';
import {LeadDto} from '../../../communication/data/requests/leadDto';
import {AppService} from '../../../app-common/services/app/app.service';
import {Customer} from '../../../customers/data/customer';
import {CommunicationDto} from '../../../communication/data/communicationDto';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'app-communication-builder',
  templateUrl: './communication-builder.component.html',
  styleUrls: ['./communication-builder.component.scss']
})
export class CommunicationBuilderComponent implements OnInit {

  @Input() commTabId: number = 0;
  @Input() lead: LeadDto;
  @Input() comm: CommunicationDto;
  @Input() newLead: { value: boolean } = {value: false};
  @Input() editorLayout: boolean = false;

  @Output() saveSuccess: EventEmitter<number> = new EventEmitter<number>();
  @Output() customerChange: EventEmitter<Customer> = new EventEmitter<Customer>();

  refreshCustomer: EventEmitter<void> = new EventEmitter<void>();
  triggerCommChange: boolean = false;

  constructor(public communicationService: CommunicationService,
              public appService: AppService,
              private loggerService: LoggerService) {
    this.communicationService = communicationService;
    this.appService = appService;
  }

  ngOnInit() {
    this.communicationService.builders.set(this.commTabId, this);
    if (!this.comm) {
      this.comm = this.communicationService.getDummyDto();
      this.lead = this.generateDummyLeadDTO();
      this.newLead = {value: false};
      this.commTabId = 0;
    }
  }

  generateDummyLeadDTO() {
    const lead = new LeadDto();
    lead.name = '';
    lead.email = '';
    lead.phoneNumber = '';
    lead.notes = '';
    return lead;
  }

  async saveToCache() {
    if (this.communicationService.builders.get(this.commTabId) === this) {
      localStorage.setItem('comm-newLead' + this.commTabId, JSON.stringify(this.newLead));
      localStorage.setItem('comm-comm' + this.commTabId, JSON.stringify(this.comm));
      localStorage.setItem('comm-lead' + this.commTabId, JSON.stringify(this.lead));
      setTimeout(() => {
        this.saveToCache();
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationBuilder, 'Save to cache');
      }, 100);
    }
  }

  async addNewCommunication() {
    if (this.newLead.value) {
      this.lead.notes = this.comm.communication.description;
      await this.communicationService
        .addLeadCommunication(this.lead, this.comm.communication, this.comm.mail, this.comm.mailChecks).then(response => {
          if (response) {
            this.saveSuccess.emit(0);
            this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationBuilder, {
              message: 'Add new communication',
              entity: this.lead
            });
            setTimeout(() => {
              this.refreshCustomer.emit();
            }, 100);
          }
        });
    } else {
      if (this.comm.communication.customerId === undefined || this.comm.communication.customerId === null || this.comm.communication.customerId === 0) {
        this.appService.showErrorMessage('You must select a customer first!');
        this.loggerService.logMessage(LogLevel.ERROR, LogSourceType.COMPONENT, LogSource.CommunicationBuilder, 'Save to cache error select a customer first');
        return;
      }
      await this.communicationService.addCustomerCommunication(this.comm.communication, this.comm.mail, this.comm.mailChecks).then(response => {
        if (response) {
          this.saveSuccess.emit(this.comm.communication.customerId);
          this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CommunicationBuilder, {
            message: 'Add customer communication success',
            entity: response
          });
        }
      });
    }
  }
}
